import Component from "@glimmer/component";
import { service } from "@ember/service";
import { trustHTML } from "@ember/template";
import dReplaceEmoji from "discourse/ui-kit/helpers/d-replace-emoji";
import { i18n } from "discourse-i18n";
import Navbar from "discourse/plugins/chat/discourse/components/chat/navbar";
import ChatThreadList from "discourse/plugins/chat/discourse/components/chat-thread-list";

export default class ChatDrawerRoutesChannelThreads extends Component {
  @service chat;
  @service chatStateManager;

  backLinkTitle = i18n("chat.return_to_list");

  get title() {
    return trustHTML(
      i18n("chat.threads.list") +
        " - " +
        dReplaceEmoji(this.args.model.channel.escapedTitle)
    );
  }

  <template>
    <div class="c-drawer-routes --channel-threads">
      {{#if @model}}
        <Navbar @onClick={{this.chat.toggleDrawer}} as |navbar|>
          <navbar.BackButton
            @route="chat.channel"
            @routeModels={{@model.channel.routeModels}}
            @title={{this.backLinkTitle}}
          />
          <navbar.Title @icon="discourse-threads" @title={{this.title}} />
          <navbar.Actions as |a|>
            <a.ToggleDrawerButton />
            <a.FullPageButton />
            <a.CloseDrawerButton />
          </navbar.Actions>
        </Navbar>

        {{#if this.chatStateManager.isDrawerExpanded}}
          <div class="chat-drawer-content">
            <ChatThreadList @channel={{@model.channel}} />
          </div>
        {{/if}}
      {{/if}}
    </div>
  </template>
}
